<template>
  <!--3d内饰-->
  <div class="dlrLayer-iframe">
    <div id="car-360-interior"></div>
    <i
      class="loadding-xx funcicons-xx"
      @click="closeInter"
      style="right: 0.8125rem; left: auto"
    ></i>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import layerManager from '../../services/layer.manager';
import { staticIdProxy, actionProxy } from '../../services/socketIO/user.action.interceptor';
import VrPorxy from '@/services/actionSync/interior.porxy.service';
import * as layerNames from '../../services/layerName';
export default {
  props: {
    specId: {
      type: [Number, String],
      default: 0,
    }
  },
  computed: {
    ...mapGetters({
      'threeDimensionHall': 'frame/threeDimensionHall',
      baseInfo: 'baseInfo',
      phoneCallStatus: 'phoneCall/phoneCallStatus'
    }),
    dealerId () {
      return this.baseInfo.dealerId;
    }
  },
  created: staticIdProxy(function () {
    return;
  }, 'realtime-interior-layer'),
  mounted () {
    this.porxy = new VrPorxy(this.specId);
    // 打开内饰页开始监听
    this.porxy.listen('viewChange');
    this.porxy.listen('sceneChange');
  },
  methods: {
    closeInter: actionProxy('closeInter', function () {
      if (this.porxy) {
        this.porxy.destroy();
      }
      if (this.threeDimensionHall.isOpen) {
        layerManager.open3dLayer();
      }
      layerManager.close(layerNames.CAR_REALTIME_INTERIOR_LAYER);
    })
  }
};
</script>
<style>
#car-360-interior > iframe {
  position: absolute;
  width: 100%;
  height: 100%;
}
</style>